module.exports = __webpack_public_path__ + "static/media/touch.e37d9c03.svg";